import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import store from '../../app/store';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export interface INotificationItem {
  id: number;
  notifications_id: number;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
  user_id: null | number;
  is_read: boolean | any;
}

export interface INotifications {
  results: Array<INotificationItem>;
  page: number;
  limit: number;
  totalResults: number;
  totalPages: number;
}

const initialState: IAuthState = {
  notifications: undefined,
  generalNotifications: [],
  personalNotifications: [],
  unreadCount: 0,
};

export interface IAuthState {
  notifications?: INotifications | null;
  generalNotifications: Array<INotificationItem>;
  personalNotifications: Array<INotificationItem>;
  unreadCount: number;
}

// Tüm bildirimleri getir (admin için)
export const notificationsList = createAsyncThunk('notifications/list', async (params: any) => {
  const notifications_id = store.getState()?.auth?.user?.company?.id;
  params = { ...params, notifications_id };
  const res = await axios.get<any>(`${REACT_APP_API_URL}/notifications/list`, { params });
  return res.data;
});

// Kullanıcının bildirimlerini getir (genel + kişiye özel)
export const notificationsMyList = createAsyncThunk('notifications/my-list', async (params: any) => {
  const res = await axios.get<any>(`${REACT_APP_API_URL}/notifications/my-list`, { params });
  return res.data;
});

// Okunmamış bildirim sayısını getir
export const notificationsUnreadCount = createAsyncThunk('notifications/unread-count', async () => {
  const res = await axios.get<any>(`${REACT_APP_API_URL}/notifications/unread-count`);
  return res.data;
});

export const notificationsRead = createAsyncThunk('notifications/read', async (data?: { id?: number; is_read?: boolean }) => {
  const res = await axios.post<any>(`${REACT_APP_API_URL}/notifications/read`, { ...data });
  return res.data;
});

export const notificationsSlice = createSlice({
  name: 'EDnotifications',
  initialState,
  reducers: {
    clearNotifications: (state) => {
      state.notifications = undefined;
      state.generalNotifications = [];
      state.personalNotifications = [];
      state.unreadCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(notificationsList.fulfilled, (state, action) => {
      state.notifications = action.payload;
    });

    builder.addCase(notificationsMyList.fulfilled, (state, action) => {
      const results = action.payload?.results || [];
      // Genel bildirimler (user_id null/undefined olanlar)
      state.generalNotifications = results.filter((n: INotificationItem) => n.user_id == null);
      // Kişiye özel bildirimler (user_id değeri olanlar)
      state.personalNotifications = results.filter((n: INotificationItem) => n.user_id != null);
      state.notifications = action.payload;
    });

    builder.addCase(notificationsUnreadCount.fulfilled, (state, action) => {
      state.unreadCount = action.payload?.unreadCount || 0;
    });

    builder.addCase(notificationsRead.fulfilled, (state, action) => {
      // Bildirim toggle edildiğinde is_read parametresine göre count güncelle
      // is_read: true ise okundu olarak işaretlendi, count azaltılır
      // is_read: false ise okunmadı olarak işaretlendi, count artırılır
      // Backend'den güncel count çekilecek
    });
  },
});

export const { clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
